import { render, staticRenderFns } from "./AdsOrderDetails.vue?vue&type=template&id=1a58a20a&scoped=true&"
import script from "./AdsOrderDetails.vue?vue&type=script&lang=js&"
export * from "./AdsOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./AdsOrderDetails.vue?vue&type=style&index=0&id=1a58a20a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a58a20a",
  null
  
)

export default component.exports